module.exports = __webpack_public_path__ + "static/img/page22.419d2bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page22.jpg
// module id = omsl
// module chunks = 0